import { render, staticRenderFns } from "./TabContrato.vue?vue&type=template&id=410a4031&"
import script from "./TabContrato.vue?vue&type=script&lang=js&"
export * from "./TabContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports